import React, { useRef, useState } from "react";
import "./ContactFormWithBackground.css";
import { useTranslation } from "react-i18next";

import girlsImg2 from "../../assets/images/about/girls-hidden.png";
import whiteArrow from "../../assets/images/Home/whiteArrow.svg";
import { Link } from "react-router-dom";
import useLangLink from "../../utils/useLangLink";
import emailjs from "@emailjs/browser";
import axios  from "axios";

const ContactFormWithBackground = () => {
  const { t } = useTranslation();
    const lp = useLangLink();
  const ts = (k, d) => t(`sections.contactForm.${k}`, d);
  const formRef = useRef(null);
  const [status, setStatus] = useState({ type: "idle", msg: "" });

  const siteName = process.env.REACT_APP_SITE_NAME || "unknown-site";

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = formRef.current;
    if (!form) return;

    const fullName = form.full_name?.value.trim() || "";
    const email = form.subscriber_email?.value.trim() || "";
    const message = form.message?.value.trim() || "";
    const phone = form.phone_number ? form.phone_number.value.trim() : "";
    const privacyChecked = form.privacy_agreed?.checked;

    // Honeypot — важно, чтобы поле было в форме


    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());
    delete data.company;
    if (form.company && form.company.value) {
      return;
    }

    // Валидация email
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setStatus({
        type: "error",
        msg: ts('errEmail'),
      });
      return;
    }

    if (!fullName) {
      setStatus({
        type: "error",
        msg: ts('errName'),
      });
      return;
    }

    if (!privacyChecked) {
      setStatus({
        type: "error",
        msg: ts('errPrivacy'),
      });
      return;
    }

    setStatus({ type: "loading", msg: ts('loading') });

    try {
      const response = await axios.post('https://assembly.tehnik.tech/api/send_form/from',  {
        project: 'offshoreadvisory',
        subject: '/',
        data: data // все данные формы
      }, {

        headers: {
          'Content-Type': 'application/json',

        }
      });

      form.reset();
      setStatus({
        type: "success",
        msg: ts('success'),
      });
    } catch (err) {
      console.error(err);
      setStatus({
        type: "error",
        msg: ts('error'),
      });
    }
  };

  return (
    <div className="contact-background-gray">
      <div className="contact-container-block">
        <div className="contact-container-left">
          <img src={girlsImg2} alt={ts('imgAlt')} />
        </div>

        <div className="contact-container-right">
          <h2 className="contact-container-title">
            {ts('title')}
          </h2>

          <form ref={formRef} onSubmit={onSubmit} noValidate>
            <div className="input-wrapper">
              <input
                type="text"
                name="full_name"
                placeholder={ts('fullName')}
                required
              />
            </div>

            <div className="input-wrapper">
              <input
                type="email"
                name="subscriber_email"
                placeholder={ts('email')}
                required
              />
            </div>

            {/* Если нужен телефон — просто раскомментируй */}
            {/* <div className="input-wrapper">
              <input
                type="tel"
                name="phone_number"
                placeholder="Phone (optional)"
              />
            </div> */}

            <div className="textarea-wrapper">
              <textarea
                name="message"
                placeholder={ts('brief')}
                rows={4}
              />
            </div>

            {/* Honeypot (скрытое поле для ботов) */}
            <input
              type="text"
              name="company"
              tabIndex={-1}
              autoComplete="off"
              className="cf-hp"
              aria-hidden="true"
            />

            <div className="agree-sending">
              <div className="agree-content">
                <input
                  type="checkbox"
                  name="privacy_agreed"
                  id="privacy_agreed"
                />
                <p>
                  {ts('agree')}{" "}<Link to={lp("/privacy-policy")}>{ts('privacy')}</Link>
                </p>
              </div>

              <button
                type="submit"
                disabled={status.type === "loading"}
              >
                {status.type === "loading" ? ts('sending') : ts('submit')}
                <img src={whiteArrow} alt="" />
              </button>
            </div>

            {/* Статус отправки */}
            <div
              className={`contact-status contact-status--${status.type}`}
              aria-live="polite"
            >
              {status.msg}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactFormWithBackground;
